import moment from 'moment';
import React from 'react';
import styles from './PublicFooter.module.scss';

const PublicFooter = () => {
  const organizationName = window?.__slab.PUBLIC_ORG.name;
  const HOST = window?.__slab.HOST;

  return (
    <div className={styles.footer}>
      &copy; {moment().format('YYYY')} {organizationName}.{' '}
      <a
        href={`https://${HOST}`}
        target="_blank"
        rel="nofollow noopener noreferrer"
      >
        Powered by Slab
      </a>
    </div>
  );
};

export default PublicFooter;
